var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAs400(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2a4j1xyk4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v1641H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nqz3p4wnib"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.666 0v.668H0V0h4.666z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2sy4cbwqc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.666 0v.67H0V0h4.666z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "alm6jph1wd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.002 0v.67H0V0h2.002z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h4s8nv2hle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.002 0v.67H0V0h2.002z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8ulfic8svf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.666 0v.67H0V0h4.666z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n6njey8hgg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.443 0a2.382 2.382 0 0 1-.266.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2ahvp1x8yh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.284 0c.22.188.407.414.56.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2vej9v2l7i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.843 0a2.494 2.494 0 0 1-.559.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tz1lu05p2j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.177 0c.114.207.204.433.266.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y9ec4sejjk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97 0c.662 0 1.268.257 1.715.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bul1u9k3jl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0v.67H0V0h2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dmmv4piwdm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.182 0c0 .23-.03.456-.09.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4jfpps2d5n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0v.67H0V0h2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uksosazvgo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.092 0c.06.214.09.44.09.67H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "37rutf57lp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.687 0c-.45.414-1.05.67-1.716.67L0 .663V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ql4craswq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0v.668H0V0h3.333z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xhacyrsgur"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.333 0v.67H0V0h3.333z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jbkqt0dfys"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.26 0 .23.67H0V0h4.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "916ay549gt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.818 0 .23.67H0V0h3.818z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "awglrx3onu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.335 0v.668H0V0h3.335z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hwypuotspv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.335 0v.67H0V0h3.335z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ux0mb75hcw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.813 0 .188.542L4.189 0h3.813v.67H6V.055L5.788.67H2.213L2.002.055V.67H0V0h3.813z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vt8sagxgox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.601 0v.67H0L.23 0h3.371z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0cjz757p7y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.048 0v.67H0L.23 0h3.818z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wl2wqcd72z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.461 0-.23.663L0 0h.461z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cn0cf6cq6A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.357 0 1.12.67H.235L0 0h1.357z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gljhl3cpiB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.254 0-.236.67H.235L0 0h2.254z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dn54s17g7C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.138 0 2.91.67H.23L0 0h3.138z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8t062iv9D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.37 0 .231.67H0V0h3.37z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r4bu3xzx2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49 0v.67H0L.228 0H4.49z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "33uy8csebF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.631 0c.123 0 .204.06.245.177L4.302 4.1c.004.012.006.03.006.055a.123.123 0 0 1-.04.089.123.123 0 0 1-.088.04h-.796a.212.212 0 0 1-.208-.135l-.22-.594H1.352l-.22.594a.212.212 0 0 1-.208.135H.129a.123.123 0 0 1-.09-.04A.123.123 0 0 1 0 4.155c0-.024.002-.043.006-.055L1.432.177C1.472.06 1.554 0 1.677 0h.954zm-.477 1.077-.545 1.56H2.7l-.545-1.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r605lfltyG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.824 0c.359 0 .67.062.933.187.263.124.465.28.606.465.14.185.215.368.223.547a.135.135 0 0 1-.037.095.12.12 0 0 1-.092.04h-.856a.236.236 0 0 1-.208-.11c-.025-.086-.088-.158-.19-.217a.746.746 0 0 0-.38-.09c-.17 0-.303.031-.397.093a.301.301 0 0 0-.14.269c0 .118.06.211.183.278.122.068.35.136.685.205.383.07.688.156.915.26.226.104.394.24.502.404.108.166.162.375.162.628 0 .277-.08.518-.239.722-.159.204-.38.36-.66.468a2.684 2.684 0 0 1-.968.162c-.395 0-.732-.057-1.01-.171C.58 4.12.37 3.969.227 3.782A1.057 1.057 0 0 1 0 3.17a.12.12 0 0 1 .04-.092.135.135 0 0 1 .095-.037h.813c.05 0 .09.008.12.025.03.016.064.045.1.085a.616.616 0 0 0 .249.242.915.915 0 0 0 .45.095c.22 0 .389-.034.507-.101.119-.067.178-.16.178-.278a.271.271 0 0 0-.092-.211.814.814 0 0 0-.294-.147 6.323 6.323 0 0 0-.581-.144C1.09 2.509.722 2.36.477 2.16.233 1.96.11 1.675.11 1.303c0-.253.07-.478.211-.676.141-.198.34-.352.6-.462.259-.11.56-.165.903-.165z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f23zkd50hH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.888 0a.12.12 0 0 1 .092.04.128.128 0 0 1 .037.089c0 .02-.004.04-.012.06L.924 5.172a.225.225 0 0 1-.226.153h-.57a.123.123 0 0 1-.088-.04.123.123 0 0 1-.04-.089c0-.02.004-.04.012-.06L2.081.152C2.125.051 2.2 0 2.307 0h.581z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rqsr9ci7fI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.998 0a.16.16 0 0 1 .114.043c.03.028.046.065.046.11v2.356h.538a.151.151 0 0 1 .16.153v.642a.152.152 0 0 1-.154.153h-.544v.674a.144.144 0 0 1-.046.11.16.16 0 0 1-.114.043h-.795a.147.147 0 0 1-.107-.046.147.147 0 0 1-.046-.107v-.674H.153a.147.147 0 0 1-.107-.045A.147.147 0 0 1 0 3.304v-.618a.31.31 0 0 1 .067-.183L1.842.104A.279.279 0 0 1 2.068 0h.93zm-.924 1.175L1.09 2.552h.985V1.175z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s2m14fg76J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78 0c.372 0 .688.07.95.208.26.139.46.327.596.566.137.239.213.511.23.817.006.095.01.253.011.473v.139c0 .286-.004.483-.012.594-.028.48-.19.868-.483 1.162-.294.294-.724.443-1.291.447-.563-.004-.992-.153-1.285-.447C.202 3.665.04 3.278.012 2.797a16.194 16.194 0 0 1 0-1.206c.017-.306.093-.578.23-.817A1.46 1.46 0 0 1 .835.208C1.095.07 1.41 0 1.781 0zm0 .912c-.366 0-.56.238-.58.716-.004.088-.006.226-.006.413v.15c0 .265.001.457.005.575.02.477.215.716.582.716.191 0 .334-.062.428-.187.094-.124.145-.3.153-.53.008-.117.012-.31.012-.574 0-.265-.004-.453-.012-.563-.008-.22-.06-.395-.153-.523-.094-.129-.237-.193-.428-.193z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m5hk8grvhK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78 0c.372 0 .688.07.95.208.26.139.46.327.596.566.137.239.213.511.23.817.006.095.01.253.011.473v.139c0 .286-.004.483-.012.594-.028.48-.19.868-.483 1.162-.294.294-.724.443-1.291.447-.563-.004-.992-.153-1.285-.447C.202 3.665.04 3.278.012 2.797a16.194 16.194 0 0 1 0-1.206c.017-.306.093-.578.23-.817A1.46 1.46 0 0 1 .835.208C1.095.07 1.41 0 1.781 0zm0 .912c-.366 0-.56.238-.58.716-.004.088-.006.226-.006.413v.15c0 .265.001.457.005.575.02.477.215.716.582.716.191 0 .334-.062.428-.187.094-.124.145-.3.153-.53.008-.117.012-.31.012-.574 0-.265-.004-.453-.012-.563-.008-.22-.06-.395-.153-.523-.094-.129-.237-.193-.428-.193z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a4j1xyk4a)",
    transform: "translate(-478 -670)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nqz3p4wnib)",
    transform: "translate(478 683.014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.666v.668H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2sy4cbwqc)",
    transform: "translate(478 681.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.666v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alm6jph1wd)",
    transform: "translate(479.331 680.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alm6jph1wd)",
    transform: "translate(479.331 679.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h4s8nv2hle)",
    transform: "translate(479.331 677.896)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h4s8nv2hle)",
    transform: "translate(479.331 676.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ulfic8svf)",
    transform: "translate(478 675.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.666v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8ulfic8svf)",
    transform: "translate(478 674.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.666v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n6njey8hgg)",
    transform: "translate(483.332 681.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h7.443v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2ahvp1x8yh)",
    transform: "translate(484.666 679.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h5.843v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2vej9v2l7i)",
    transform: "translate(484.666 677.896)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h5.843v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tz1lu05p2j)",
    transform: "translate(483.332 675.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h7.443v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y9ec4sejjk)",
    transform: "translate(483.332 674.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h6.685v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bul1u9k3jl)",
    transform: "translate(484.666 676.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dmmv4piwdm)",
    transform: "translate(488.666 676.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.182v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4jfpps2d5n)",
    transform: "translate(484.666 680.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uksosazvgo)",
    transform: "translate(488.666 680.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.182v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#37rutf57lp)",
    transform: "translate(483.332 683.014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h6.687v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ql4craswq)",
    transform: "translate(491.334 683.014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.333v.668H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xhacyrsgur)",
    transform: "translate(491.334 681.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.333v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alm6jph1wd)",
    transform: "translate(492.665 680.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alm6jph1wd)",
    transform: "translate(492.665 679.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jbkqt0dfys)",
    transform: "translate(491.334 675.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.49v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#916ay549gt)",
    transform: "translate(491.334 674.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.048v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#awglrx3onu)",
    transform: "translate(498.665 683.014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.335v.668H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hwypuotspv)",
    transform: "translate(498.665 681.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.335v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alm6jph1wd)",
    transform: "translate(498.665 680.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alm6jph1wd)",
    transform: "translate(498.665 679.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ux0mb75hcw)",
    transform: "translate(492.665 677.896)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h8.002v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vt8sagxgox)",
    transform: "translate(497.065 676.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.601v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0cjz757p7y)",
    transform: "translate(497.952 674.056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.048v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wl2wqcd72z)",
    transform: "translate(496.435 683.014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h.461v.663H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cn0cf6cq6A)",
    transform: "translate(495.988 681.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h1.357v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gljhl3cpiB)",
    transform: "translate(495.539 680.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h2.254v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dn54s17g7C)",
    transform: "translate(495.097 679.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.138v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8t062iv9D)",
    transform: "translate(492.665 676.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.601v.67H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r4bu3xzx2E)",
    transform: "translate(497.51 675.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.49v.67H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#33uy8csebF)",
    transform: "translate(478 685.465)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h4.308v4.284H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r605lfltyG)",
    transform: "translate(482.528 685.404)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.733v4.406H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f23zkd50hH)",
    transform: "translate(486.573 684.939)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.017v5.324H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqsr9ci7fI)",
    transform: "translate(489.902 685.465)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.855v4.284H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s2m14fg76J)",
    transform: "translate(494.247 685.404)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.568v4.406H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m5hk8grvhK)",
    transform: "translate(498.432 685.404)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0072C7",
    d: "M0 0h3.568v4.406H0V0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs400);
export default __webpack_public_path__ + "static/media/as400.926253b719858dd0d4f01241ecbf4f11.svg";
export { ForwardRef as ReactComponent };